/**
 * Formats a voter count into a threshold display string.
 * Thresholds: 0, 100+, 500+, 1k+, 5k+, 10k+
 * e.g., 0 → "0", 73 → "0", 150 → "100+", 600 → "500+", 1200 → "1k+", 15000 → "10k+"
 */
export function formatVoterCount(count) {
  if (!count || count < 100) return '0';
  if (count < 500) return '100+';
  if (count < 1000) return '500+';
  if (count < 5000) return '1k+';
  if (count < 10000) return '5k+';
  return '10k+';
}
